export enum AppRoute {
  Home = 'home',
  Subscribe = 'subscribe',
  Callback = 'callback',
  App = 'app'
}
